import Cookies from "js-cookie";
import { Suspense, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Scroll_To_Top from "./components/ui/scroll_to_top/Scroll_To_Top";
import App_Routes from "./routes/App_Routes";
import Loading from "./components/feedback/Loading";
import SEO from "./components/ui/Seo";

// Languages
const languages = [
  { code: "en", name: "English", country_code: "gb", dir: "ltr" },
  { code: "ar", name: "العربية", country_code: "sa", dir: "rtl" },
];

const App = () => {
  const { t, i18n } = useTranslation();
  const currentLanguageCode = i18n.language;
  const currentLanguage = useMemo(() => {
    return (
      languages.find((l) => l.code === currentLanguageCode) || languages[0]
    );
  }, [currentLanguageCode]);

  // Set page direction and language cookie
  useEffect(() => {
    document.documentElement.lang = currentLanguage.code;
    document.body.dir = currentLanguage.dir;

    Cookies.set("i18next", currentLanguageCode);
  }, [currentLanguage, currentLanguageCode]);
  return (
    <Suspense fallback={<Loading />}>
      <SEO
        title={t("seo.page_title")}
        description={t("seo.description")}
        ogTitle={t("seo.og_title")}
        ogDescription={t("seo.og_description")}
        keywords={t("seo.keywords")}
      />
      <Scroll_To_Top />
      <App_Routes />
    </Suspense>
  );
};

export default App;
